<template>
  <div class="roma-page-content fill-height bg-white">
    <v-row justify="space-between" align="center">
      <v-col cols="12" sm="12" md="4" lg="4" class="d-flex align-center">
        <h1 class="titulo-2 color-purpura-base">
          Tareas Enviadas
        </h1>
      </v-col>
      
    </v-row>
    <v-row>
      <v-col cols="12">
        <TaskFilter /> 
        <TaskList />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TaskFilter from "@/components/task/TaskFilter.vue";
import { mapGetters, mapActions } from "vuex";
import TaskList from "@/components/task/TaskList.vue";

export default {
  components: { TaskFilter, TaskList },
  props: {
    sidebarExpanded: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.setLayout("main-layout");
    this.actionGetFilterInformationLesson(this.user());
    this.actionGetTasks({ pageNumber: 0, pageSize: 8 });
  },
  methods: {
    ...mapGetters({
      layout: "getLayout",
      user: "getUserData"
    }),
    ...mapActions({
      setLayout: "setLayout",
      actionGetFilterInformationLesson: "actionGetFilterInformationLesson",
      actionGetTasks: "actionGetTasks"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";
@import "../../assets/styles/generals";
h2 {
  /*transform: translateY(7px);*/
  color: map-get($colors, "purple");
}
</style>
